// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  HOME_SET_HOME_STATE,
} from './constants';

export function setHomeState(data) {
  return {
    type: HOME_SET_HOME_STATE,
    data:data
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_SET_HOME_STATE:
      return {
        ...state,
        metaData:action.data.metaData,
        onwardPBDate:action.data.onwardPBDate,
        returnPBDate:action.data.returnPBDate,
        pbSourceCity:action.data.pbSourceCity,
        pbDestinationCity:action.data.pbDestinationCity,

      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/setHomeState.js